export interface ContextMenuItem {
  label?: string;
  type?: 'normal' | 'check' | 'separator' | 'slider';
  checked?: boolean;
  value?: number;
  onClick?: () => void;
  onChange?: (value: number) => void;
}

export interface ContextMenu {
  element: HTMLElement;
  show: (x: number, y: number, items: ContextMenuItem[]) => void;
  hide: () => void;
}

export function createContextMenu(): ContextMenu {
  const menu = document.createElement('div');
  menu.className = 'context-menu dropdown-menu';
  menu.style.display = 'none';
  document.body.appendChild(menu);

  function render(items: ContextMenuItem[]) {
    menu.innerHTML = '';
    for (const item of items) {
      if (item.type === 'separator') {
        const sep = document.createElement('div');
        sep.className = 'menu-sep';
        menu.appendChild(sep);
        continue;
      }

      if (item.type === 'slider') {
        const el = document.createElement('div');
        el.className = 'menu-item slider-item';
        el.innerHTML = `<span>${escapeHtml(item.label || '')}</span>`;
        const input = document.createElement('input');
        input.type = 'range';
        input.min = '0';
        input.max = '100';
        input.value = String(Math.round((item.value ?? 1) * 100));
        input.addEventListener('click', (e) => e.stopPropagation());
        input.addEventListener('input', (e) => {
          const value = parseInt((e.target as HTMLInputElement).value, 10) / 100;
          item.onChange?.(value);
        });
        el.appendChild(input);
        menu.appendChild(el);
        continue;
      }

      const el = document.createElement('div');
      el.className = 'menu-item' + (item.type === 'check' ? ' check-item' : '') + (item.checked ? ' active' : '');
      el.innerHTML = `<span>${escapeHtml(item.label || '')}</span>`;
      if (item.type === 'check') {
        el.innerHTML += `
          <span class="checkbox-indicator">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M19.06 6.94a1.5 1.5 0 0 1 0 2.12l-8 8a1.5 1.5 0 0 1-2.12 0l-4-4a1.5 1.5 0 0 1 2.12-2.12L10 13.88l6.94-6.94a1.5 1.5 0 0 1 2.12 0Z" clip-rule="evenodd"/></svg>
          </span>
        `;
      }
      el.addEventListener('click', (e) => {
        e.stopPropagation();
        item.onClick?.();
        hide();
      });
      menu.appendChild(el);
    }
  }

  function show(x: number, y: number, items: ContextMenuItem[]) {
    render(items);
    menu.style.display = 'block';
    const rect = menu.getBoundingClientRect();
    let left = x;
    let top = y;
    if (left + rect.width > window.innerWidth) left = window.innerWidth - rect.width - 8;
    if (top + rect.height > window.innerHeight) top = window.innerHeight - rect.height - 8;
    menu.style.left = Math.max(8, left) + 'px';
    menu.style.top = Math.max(8, top) + 'px';
  }

  function hide() {
    menu.style.display = 'none';
  }

  document.addEventListener('click', (e) => {
    if (!menu.contains(e.target as Node)) {
      hide();
    }
  });

  return { element: menu, show, hide };
}

function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
